import { createAction } from '@ngrx/store';
import { props } from '@ngrx/store';
import { CurrentInvestmentModel } from './state';

export const RequestCurrentDataAction = createAction('[investment option View] request current data by Id', props<{ account: number }>());

export const ResponseCurrentDataAction = createAction('[Edit investment option View] response current data by Id',
  props<{ payload: CurrentInvestmentModel }>());

